import { render, staticRenderFns } from "./WorkRegionModal.vue?vue&type=template&id=b9738978&"
import script from "./WorkRegionModal.vue?vue&type=script&lang=js&"
export * from "./WorkRegionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports